import React from 'react';
import Logo from '../../Logo/Logo';
import Menu from '../SideDrawer/Menu/Menu';
import classes from './Toolbar.module.css';
import NavigationItems from '../NavigationItems/NavigationItems';

// LANG

const toolbar = (props) => {
    let attachClasses = [classes.HeaderWrapper];

    if(props.homePage) {
        attachClasses = [classes.HeaderWrapper, classes.HomePage]
    } 
    
    if (props.homePage && props.windowSrolled) {
        attachClasses = [classes.HeaderWrapper, classes.WindowScrollY, classes.HomePage]
    }

    // if (!propd.homePage) {
    //     attachClasses = [classes.HeaderWrapper, classes.WindowScrollY, classes.HomePage, ]
    // }

    return (
        <header className={attachClasses.join(' ')}>
                <div className={classes.ToolbarLogo}>
                    <Logo />
                </div>
                <Menu clicked={props.menuClicked}/>
                <nav className={classes.DesktopOnly}>
                    <NavigationItems />
                </nav>
        </header>
    )
};

export default toolbar;